import { Injectable } from '@angular/core';
import { CommonHttpService } from '../common-http/common-http.service';
import { endPoints } from '../../shared/core/app.config';
import { ExternalValidationRequest, ExternalValidationResponse } from '../../shared/models';
import { Observable, of } from 'rxjs';
import { TaxCodeContext } from '../../shared/models/taxcodecontext.model';
import { SharedSettingsService } from '../settings/settings-base.service';
import { SessionStorageService } from 'angular-web-storage';
@Injectable({
  providedIn: 'root'
})
export class GlobalFunctionService {
    private globalApiURL = `${endPoints.apiUrl}${endPoints.endPointName.globalfunctionApi}`;


    constructor(private commonHttpService: CommonHttpService,
                private sharedStorage: SharedSettingsService,
                private sessionStorage: SessionStorageService) {
      
    }

    getUsingGlobalFunctionAPIMethod(request: string, defaultValue: string): Observable<string> {  

      const parsedFunction = this.parseApiFunction(request);
      if (!parsedFunction) {
        return of(defaultValue);
      }
      
      const { methodName, arguments: args } = parsedFunction;
      let data: TaxCodeContext | { args: string[] } | null = null;
      switch (methodName) {
        case 'GetTaxRate':
          if (args.length !== 0) {                      
            data = this.buildTaxCodeRequestObject(args[0], args);      
            if (data === null) {
              return of(defaultValue);
            }
          }
          break;
        default:
          data = { args: args }; break;
      }
      const globalMethodUrl = `${this.globalApiURL}${methodName}`;
      return this.commonHttpService.httpPostServiceWithDefaultReturn(globalMethodUrl, data, defaultValue);
    }
    /**
     * Parses a global function string in the format "MethodName(arg1, arg2, ...)".
     * @param globalFunction The string representing the function call.
     * @returns An object with methodName and arguments array if parsing succeeds, otherwise null.
     */
    parseApiFunction(globalFunction: string): { methodName: string, arguments: string[] } | null {
    const match = globalFunction.trim().match(/^(\w+)\((.*)\)$/);
    if (!match) {return null;}
    else {
        const methodName = match[1];
        const args = match[2].split(',').map(arg => arg.trim());
        return { methodName, arguments: args };
    }
  }
    buildTaxCodeRequestObject(taxCode: string, args: string[] ): TaxCodeContext | null {
    const inceptionDate = this.sessionStorage.get('InceptionDate');
    const productTemplateId = this.sharedStorage.productId;
    if (productTemplateId && taxCode) {
       const staticParam = {
        inceptionDate: inceptionDate, productTemplateId: productTemplateId, taxCode: taxCode, subDivision: '', productClass: ''}
       const dynamicKeys: (keyof TaxCodeContext)[] = ['taxCode', 'subDivision', 'productClass'];
       const model = this.buildModelFromArguments<TaxCodeContext>(staticParam, args, dynamicKeys);
       return model;
    }
    return null;
  }
    buildModelFromArguments<T>(staticParam: Partial<T>, args: string[], dynamicKeys: (keyof T)[]): T  {
    const model: T = { ...staticParam } as T;
    dynamicKeys.forEach((key, index) => {
      model[key] = index < args.length ? args[index] as any : null;
    });
    return model;
  }
}